/*
 * Author: Harper Yan
 * File Created: Sunday, 24-07-21 10:45 am
 * Last Modified: Monday, 25-03-17 03:18 pm, by Harper Yan
 */

import type { IconType } from '@ucard/ds/Icon';
interface NavBarItemType {
  label: string;
  icon: IconType;
  href: string;
}
export const NavBarItems: NavBarItemType[] = [{
  label: 'navBar.0',
  icon: 'Wallet',
  href: '/dvault'
}, {
  label: 'navBar.1',
  icon: 'Card',
  href: '/card'
}, {
  label: 'navBar.2',
  icon: 'User',
  href: '/account'
}];